import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return null; // or a spinner 
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }

    return children;
}